import { mapObjectValues, mergeWithDefaults } from '@aline/common';
import { isHotkey } from 'is-hotkey';
import { IS_APPLE } from 'src/helpers/environment';

export interface Hotkey<O> {
  action?: (options: O) => void;
  apple?: Hotkey<O>;
  hint?: string;
  key?: string | string[];
  pc?: Hotkey<O>;
  test?: (event: KeyboardEvent) => boolean;
}

/**
 * Create a hotkey map with a given options type O, automatically selecting the correct hotkeys for
 * the current platform.
 *
 * Curried by necessity as a workaround for https://github.com/microsoft/TypeScript/issues/26242.
 */
export function createHotkeys<O = void>() {
  return <K extends string>(config: Record<K, Hotkey<O>>): Record<K, Hotkey<O>> =>
    mapObjectValues(config, hotkey => {
      const osKey = IS_APPLE ? hotkey.apple : hotkey.pc;
      const mergedHotkey = mergeWithDefaults(osKey ?? {}, hotkey);
      mergedHotkey.test ??= event => !!mergedHotkey.key && isHotkey(mergedHotkey.key, event);
      return mergedHotkey;
    });
}
